﻿$.fn.dxCtrlBcChkLienAppli = function custom_dxCtrlBcChkLienAppli(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlbcchklienappli dx-ctrl");
        this.createInstance(new cdxCtrlBcChkLienAppli(this, option));
    }
    return this;
}

window.cdxCtrlBcChkLienAppli = function (container, option) {
    var Me = this

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();
        var lstValue = []
        if (typeof option.data != 'undefined') {
            if (typeof option.data.id_bc_article != 'undefined') {
                lstValue = option.bddCtrl.mGetArray("bc_appli").filter(function (o) {
                    return option.bddCtrl.mGetArray("bc_article_bc_appli").filter(function (o2) {
                        return option.data.id_bc_article == o2.id_bc_article && o.id_bc_appli == o2.id_bc_appli
                    }).length > 0
                })
            } else if (typeof option.data.id_bc_dossier != 'undefined') {
                lstValue = option.bddCtrl.mGetArray("bc_appli").filter(function (o) {
                    return option.bddCtrl.mGetArray("bc_dossier_bc_appli").filter(function (o2) {
                        return option.data.id_bc_dossier == o2.id_bc_dossier && o.id_bc_appli == o2.id_bc_appli
                    }).length > 0
                })
            } else {
                lstValue = option.bddCtrl.mGetArray("bc_appli").filter(function (o) {
                    return option.bddCtrl.mGetArray("bc_qr_bc_appli").filter(function (o2) {
                        return option.data.id_bc_qr == o2.id_bc_qr && o.id_bc_appli == o2.id_bc_appli
                    }).length > 0
                })
            }
        }
        var opt = {
            bddCtrl: option.bddCtrl,
            dataSource: gestCognoss.mGetDsAppliWithoutNull(),
            value: lstValue,
            valueExpr: "code_appli",
            displayExpr: "nom",
            layout: "horizontal",
            maxWidth: 160,
            itemTemplate: function (itemDataAppli, contentElement) {
                $("<div>" + itemDataAppli.nom + "</div>").appendTo(contentElement)
                if (typeof option.data.id_bc_qr == 'undefined') {
                    $DivLink = $("<div style='font-size:70%;opacity:0.5;'/>").appendTo(contentElement)
                    option.bddCtrl.getObjet(option.data).objetMetier.mGetElementLink(itemDataAppli).appendTo($DivLink)
                }
            }
        }
        if (typeof option.data != 'undefined') {
            opt.onValueChanged = function (e) {
                e.chk.option("disabled", true)
                if (typeof e.addedValue != 'undefined') {
                    var newData = null
                    var addedBcAppli = gestCognoss.mGetDsAppliWithoutNull().filter(function (o) { return o.code_appli == e.addedValue.code_appli })[0].bcAppli
                    if (typeof option.data.id_bc_article != 'undefined') {
                        newData = option.bddCtrl.getObjet("bc_article_bc_appli").mGetNewData()
                        newData.id_bc_article = option.data.id_bc_article
                        newData.id_bc_appli = addedBcAppli.id_bc_appli
                    } else if (typeof option.data.id_bc_dossier != 'undefined') {
                        newData = option.bddCtrl.getObjet("bc_dossier_bc_appli").mGetNewData()
                        newData.id_bc_dossier = option.data.id_bc_dossier
                        newData.id_bc_appli = addedBcAppli.id_bc_appli
                    } else {
                        newData = option.bddCtrl.getObjet("bc_qr_bc_appli").mGetNewData()
                        newData.id_bc_qr = option.data.id_bc_qr
                        newData.id_bc_appli = addedBcAppli.id_bc_appli
                    }
                    option.bddCtrl.getObjet(newData).mSave(function () {
                        //e.chk.option("disabled", false)
                        mConstruit()
                    })
                }
                if (typeof e.removedValue != 'undefined') {
                    var delData = null
                    var removedBcAppli = gestCognoss.mGetDsAppliWithoutNull().filter(function (o) { return o.code_appli == e.removedValue.code_appli })[0].bcAppli
                    if (typeof option.data.id_bc_article != 'undefined') {
                        delData = option.bddCtrl.mGetArray("bc_article_bc_appli").filter(function (o) {
                            return o.id_bc_article == option.data.id_bc_article &&
                                o.id_bc_appli == removedBcAppli.id_bc_appli
                        })[0]
                    } else if (typeof option.data.id_bc_article != 'undefined') {
                        delData = option.bddCtrl.mGetArray("bc_dossier_bc_appli").filter(function (o) {
                            return o.id_bc_dossier == option.data.id_bc_dossier &&
                                o.id_bc_appli == removedBcAppli.id_bc_appli
                        })[0]
                    } else {
                        delData = option.bddCtrl.mGetArray("bc_qr_bc_appli").filter(function (o) {
                            return o.id_bc_qr == option.data.id_bc_qr &&
                                o.id_bc_appli == removedBcAppli.id_bc_appli
                        })[0]
                    }
                    option.bddCtrl.getObjet(delData).mDelDataDefinitif(function () {
                        //e.chk.option("disabled", false)
                        mConstruit()
                    })
                }
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged(dxLstChk.option("value"))
            }
        } else {
            opt.onValueChanged = function (e) {
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged(dxLstChk.option("value"))
            }
        }

        var dxLstChk = $("<div/>").appendTo(container).dxCtrlLstCheckBox(opt).dxCtrlLstCheckBox("instance")
    }

    this.element = function () { return container; }

    mConstruit();
}